import { render } from "./sidebar.vue?vue&type=template&id=15151976&ts=true"
import script from "./sidebar.vue?vue&type=script&lang=ts"
export * from "./sidebar.vue?vue&type=script&lang=ts"

import "./sidebar.vue?vue&type=style&index=0&id=15151976&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__